import { Close } from "@mui/icons-material";
import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import React from "react";
import { SalesAidsStyles } from "./SalesAidsStyles";
import { options } from "../../../../../utils/Utils";

const TradeVehicleArtifacts = ({ artifacts, setArtifacts, edit }) => {
  const handleTextChange = (field, value) => {
    setArtifacts((prev) => ({
      ...prev,
      trade_artifact: {
        ...prev.trade_artifact,
        [field]: value,
        isEdit: true,
      },
    }));
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 2,
        p: "6px",
        borderRadius: 2,
        bgcolor: artifacts?.isEdit ? "#FFF7F7" : null,
        alignItems: "flex-start",
      }}
    >
      {/* English Column */}
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography fontSize={15} fontWeight="bold" color="gray">
          English
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          label={"Message to be displayed"}
          onChange={(e) => handleTextChange("text", e.target.value)}
          value={artifacts?.text}
          multiline
        />
      </Box>

      {/* Spanish Column */}
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography fontSize={15} fontWeight="bold" color="gray">
          Spanish
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          label={"Mensaje a mostrar"}
          onChange={(e) => handleTextChange("es_text", e.target.value)}
          value={artifacts?.es_text}
          multiline
        />
      </Box>
    </Box>
  );
};

export default TradeVehicleArtifacts;
